import type { SOURCES_TEXT } from "app/components/widget/widget-types/WidgetConstants";
import { BasicDurations } from "app/services/DurationService";
import { PngHeader as PngHeaderView } from "app/UtilitiesAndConstants/UtilitiesComponents/PngHeader";

import { useHighLevelMetricsContext } from "../context";

export const PngHeader = () => {
    const { params, selectedMetric, durations } = useHighLevelMetricsContext();

    const { country, webSource, duration } = params;
    const is28d = duration === BasicDurations.LAST_TWENTY_EIGHT_DAYS;

    if (!selectedMetric) {
        return null;
    }

    const metricTitle = selectedMetric.getTitle({ is28d });

    return (
        <PngHeaderView
            metricTitle={metricTitle}
            durations={durations?.forWidget || []}
            webSource={webSource as keyof (typeof SOURCES_TEXT)["websites"]}
            country={Number(country) || 999}
        />
    );
};
